import { theme } from '@frontend/theme';

export const containerStyles = (isActive: boolean) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(0.25, 1),
  border: `1px solid ${isActive ? theme.colors.primary5 : theme.colors.neutral50}`,
  borderRadius: theme.borderRadius.small,
  backgroundColor: isActive ? theme.colors.primary5 : 'transparent',
  cursor: isActive ? 'default' : 'pointer',
  '&:hover': {
    borderColor: isActive ? theme.colors.primary5 : theme.colors.neutral10,
    backgroundColor: isActive ? theme.colors.primary5 : theme.colors.neutral10,
  },
  '&:active': {
    borderColor: isActive ? theme.colors.primary50 : theme.colors.neutral10,
  },
});

export const countBadgeStyles = {
  countBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 16,
    padding: theme.spacing(0, 0.5),
    borderRadius: theme.borderRadius.full,
    backgroundColor: theme.colors.critical50,
    color: theme.colors.white,
  },
};

export const closeIconStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 16,
  height: 16,
  '&:hover': {
    border: 'none',
    backgroundColor: theme.colors.white,
  },
};
